__turbopack_context__.v({
  "avatar": "MembersSection-module-scss-module__d3PmyG__avatar",
  "avatarActive": "MembersSection-module-scss-module__d3PmyG__avatarActive",
  "avatarInactive": "MembersSection-module-scss-module__d3PmyG__avatarInactive",
  "content": "MembersSection-module-scss-module__d3PmyG__content",
  "detail": "MembersSection-module-scss-module__d3PmyG__detail",
  "detailFacts": "MembersSection-module-scss-module__d3PmyG__detailFacts",
  "detailLabel": "MembersSection-module-scss-module__d3PmyG__detailLabel",
  "detailName": "MembersSection-module-scss-module__d3PmyG__detailName",
  "detailQuote": "MembersSection-module-scss-module__d3PmyG__detailQuote",
  "fillBase": "MembersSection-module-scss-module__d3PmyG__fillBase",
  "fillRadiate": "MembersSection-module-scss-module__d3PmyG__fillRadiate",
  "grid": "MembersSection-module-scss-module__d3PmyG__grid",
  "inner": "MembersSection-module-scss-module__d3PmyG__inner",
  "member-radiate": "MembersSection-module-scss-module__d3PmyG__member-radiate",
  "memberCol": "MembersSection-module-scss-module__d3PmyG__memberCol",
  "nameBtn": "MembersSection-module-scss-module__d3PmyG__nameBtn",
  "nameBtnActive": "MembersSection-module-scss-module__d3PmyG__nameBtnActive",
  "overline": "MembersSection-module-scss-module__d3PmyG__overline",
  "paletteGold": "MembersSection-module-scss-module__d3PmyG__paletteGold",
  "palettePine": "MembersSection-module-scss-module__d3PmyG__palettePine",
  "paletteRust": "MembersSection-module-scss-module__d3PmyG__paletteRust",
  "panel": "MembersSection-module-scss-module__d3PmyG__panel",
  "section": "MembersSection-module-scss-module__d3PmyG__section",
  "title": "MembersSection-module-scss-module__d3PmyG__title",
});
